import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { StepsModule } from 'primeng/steps';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService, MenuItem } from 'primeng/api';
import { OggettoIntervento } from '../../../models/oggetto-intervento.model';
import { Bacino } from '../../../models/bacino.model';
import { Comune } from '../../../models/comune.model';
import { Accessibilita } from '../../../models/accessibilita.model';
import { NGXLogger } from 'ngx-logger';
import { StiliService } from '../../../services/stili.service';
import { SchedeService } from '../../../services/schede.service';
import { BaciniService } from '../../../services/bacini.service';
import { ComuniService } from '../../../services/comuni.service';
import * as maplibregl from 'maplibre-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { Scheda } from '../../../models/scheda.model';
import { CodiceATO } from '../../../models/codice-ato.model';
import { StatoApprovazione } from '../../../models/stato-approvazione.model';
import { CreazioneSchedaDTO } from '../../../models/requests/scheda-creazione.model';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import proj4 from 'proj4';
import { NuovoCodiceATO } from '../../../models/nuovo-codice-ato.model';

@Component({
  selector: 'app-nuova-scheda',
  templateUrl: './nuova-scheda.component.html',
  styleUrls: ['./nuova-scheda.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    InputNumberModule,
    CalendarModule,
    ToastModule,
    TooltipModule,
    StepsModule,
    FileUploadModule,
  ]
})
export class NuovaSchedaComponent implements OnInit, AfterViewInit {
  @Output() schedaCreata = new EventEmitter<any>();
  @ViewChild('map') mapContainer!: ElementRef;
  @Input() isEnteEsecutore: boolean = false;

  visible: boolean = false;
  showCodiceModal: boolean = false;
  codiceSchedaCreata: string = '';
  codiceCopiato: boolean = false;
  schedaCreataCompleta: Scheda | null = null;
  schedaForm!: FormGroup;
  codiciAto: NuovoCodiceATO[] = [];
  codiciAtoFiltrati: NuovoCodiceATO[] = [];
  oggettiIntervento: OggettoIntervento[] = [];
  bacini: Bacino[] = [];
  comuni: Comune[] = [];
  accessibilita: Accessibilita[] = [];
  submitting: boolean = false;

  annoCorrente: number = new Date().getFullYear();
  anni: number[] = [];

  // Wizard properties
  currentStep: number = 0;
  items: MenuItem[];
  uploadedPdfName: string = '';
  uploadedExcelName: string = '';
  uploadedPdf: File | null = null;
  uploadedExcel: File | null = null;
  uploadedGeoJSON: File | null = null;
  mapInitialized: boolean = false;
  confiniComuniCaricati: boolean = false;

  // Aggiungiamo proprietà per gestire i comuni filtrati
  comuniOriginali: Comune[] = [];
  comuniFiltrati: Comune[] = [];
  private map: any = null;
  opzioniMappa = {
    mostraComuni: true
  };

  private draw: any = null;
  modoDisegno: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private logger: NGXLogger,
    private schedeService: SchedeService,
    public stiliService: StiliService,
    private baciniService: BaciniService,
    private comuniService: ComuniService,
    private firebaseStorageService: FirebaseStorageService
  ) {

    this.schedaForm = this.fb.group({
      bacino: [null, Validators.required],
      comune: [{value: null, disabled: true}, Validators.required],
      rioLocalita: [''],
     // titolo: ['', Validators.required],
      codiceAto: [{value: null, disabled: true}, Validators.required],
      oggettoIntervento: [null, Validators.required],
      frequenza: [1],
      accessibilita: [null],
      note: ['']
    });

    // Aggiungiamo un listener al campo bacino per abilitare/disabilitare il campo comune
    this.schedaForm.get('bacino')?.valueChanges.subscribe(value => {
      const comuneControl = this.schedaForm.get('comune');
      if (value) {
        comuneControl?.enable();
      } else {
        comuneControl?.disable();
        comuneControl?.setValue(null);
      }
    });

    // Aggiungiamo un listener al campo oggettoIntervento per abilitare/disabilitare il campo codiceAto
    this.schedaForm.get('oggettoIntervento')?.valueChanges.subscribe(value => {
      const codiceAtoControl = this.schedaForm.get('codiceAto');
      if (value) {

        // Filtriamo i codici ATO in base all'oggetto selezionato
        this.codiciAtoFiltrati = this.codiciAto.filter(codiceAto => {
          const match = value.codiciAto.some((codiceObj: any) => {
            const result = codiceObj.codice === codiceAto.codice;
            return result;
          });
          return match;
        });

        codiceAtoControl?.enable();
      } else {
        this.codiciAtoFiltrati = [];
        codiceAtoControl?.disable();
        codiceAtoControl?.setValue(null);
      }
    });

    // Inizializzazione del wizard
    this.items = [
      { label: 'Dati Scheda', command: (event) => this.currentStep = 0 },
      { label: 'Allegati', command: (event) => this.currentStep = 1 },
      { label: 'Posizione', command: (event) => this.currentStep = 2 }
    ];
  }

  ngOnInit(): void {
    // Non carichiamo i dati qui, ma solo quando la finestra viene aperta
  }

  ngAfterViewInit(): void {
    // Non inizializziamo subito la mappa, lo faremo quando serve
  }
  private caricaBacini(): void {
    if(this.isEnteEsecutore){
      this.baciniService.getBaciniByEnteEsecutore().subscribe(bacini => {
        this.bacini = bacini;
        // this.logger.info('[NUOVA SCHEDA] Bacini caricati con successo '+ this.bacini.length);
      });
    }else{
      this.baciniService.getBacini().subscribe(bacini => {
        this.bacini = bacini;
        // this.logger.info('[NUOVA SCHEDA] Bacini caricati con successo '+ this.bacini.length);
      });
    }
  }

  private caricaCodiciAto(): void {
    this.schedeService.getCodiciAto().subscribe(codiciAto => {
      this.codiciAto = codiciAto;
      /* // Se c'è già un oggetto selezionato, filtriamo i codici ATO
      const oggettoSelezionato = this.schedaForm.get('oggettoIntervento')?.value;
      if (oggettoSelezionato) {
        this.codiciAtoFiltrati = this.codiciAto.filter(codiceAto =>
          oggettoSelezionato.codiciAto.some((codice: string) => codice === codiceAto.codice)
        );
      } else {
        this.codiciAtoFiltrati = [];
      } */
    });
  }

  private caricaComuni(): void {
    this.comuniService.get().subscribe(comuni => {
      this.comuniOriginali = comuni; // Salviamo tutti i comuni
      this.comuni = comuni; // All'inizio mostriamo tutti i comuni
      // this.logger.info('[NUOVA SCHEDA] Comuni caricati con successo '+ this.comuni.length);
    });
  }

  private caricaOggettiIntervento(): void {
    this.schedeService.getOggettiIntervento().subscribe(oggettiIntervento => {
      this.oggettiIntervento = oggettiIntervento;
      // this.logger.info('[NUOVA SCHEDA] Oggetti intervento caricati con successo '+ this.oggettiIntervento.length);
    });
  }

  private caricaLivelliAccessibilita(): void {
    this.schedeService.getLivelliAccessibilita().subscribe(livelliAccessibilita => {
      this.accessibilita = livelliAccessibilita;
      // this.logger.info('[NUOVA SCHEDA] Livelli accessibilita caricati con successo '+ this.accessibilita.length);
    });
  }

  private caricaDatiDiRiferimento(): void {
    // Non inizializziamo la mappa qui, ma solo quando necessario
    this.caricaBacini();
    this.caricaComuni();
    this.caricaOggettiIntervento();
    this.caricaLivelliAccessibilita();
    this.caricaCodiciAto();
  }

  show(): void {
    this.visible = true;
    // Carichiamo i dati di riferimento quando la finestra viene aperta
    this.caricaDatiDiRiferimento();
    // Resettare il wizard quando si apre il dialogo
    this.currentStep = 0;
    this.resetFileUploads();
  }

  hide(): void {
    this.visible = false;
    this.resetForm();
  }

  /**
   * Chiude la modale del codice e completa la creazione della scheda
   */
  chiudiModaleCodice(): void {
    this.showCodiceModal = false;
    if (this.schedaCreataCompleta) {
      this.schedaCreata.emit(this.schedaCreataCompleta);
    }
    this.reset();
    this.schedaCreataCompleta = null;
  }

  /**
   * Copia il codice della scheda negli appunti
   */
  copiaCodice(): void {
    navigator.clipboard.writeText(this.codiceSchedaCreata).then(() => {
      this.codiceCopiato = true;
      this.messageService.add({
        severity: 'success',
        summary: 'Codice copiato',
        detail: 'Il codice è stato copiato negli appunti',
        life: 2000
      });
      setTimeout(() => {
        this.codiceCopiato = false;
      }, 2000);
    }).catch(err => {
      console.error('Errore durante la copia:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Impossibile copiare il codice',
        life: 3000
      });
    });
  }

  resetForm(): void {
    this.schedaForm.reset();
    this.currentStep = 0;
    this.resetFileUploads();
  }

  resetFileUploads(): void {
    this.uploadedPdf = null;
    this.uploadedExcel = null;
    this.uploadedGeoJSON = null;
    this.uploadedPdfName = '';
    this.uploadedExcelName = '';
  }

  onStepChange(index: number): void {
    // Verificare se lo step corrente è valido prima di passare al successivo
    if (index > this.currentStep && !this.isStepValid(this.currentStep)) {
      return;
    }

    this.currentStep = index;

    // Inizializzare la mappa solo se passiamo allo step della mappa e c'è un GeoJSON caricato
    if (this.currentStep === 2 && this.uploadedGeoJSON) {
      // Attendiamo che il DOM sia pronto e poi inizializziamo la mappa
      setTimeout(() => {
        this.initializeMap();
      }, 500);
    }
  }

  nextStep(): void {
    if (this.currentStep < 2 && this.isStepValid(this.currentStep)) {
      this.currentStep++;

      // Inizializzare la mappa solo se passiamo allo step della mappa e c'è un GeoJSON caricato
      if (this.currentStep === 2 && this.uploadedGeoJSON) {
        setTimeout(() => {
          this.initializeMap();
        }, 500);
      }
    }
  }

  previousStep(): void {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  isStepValid(step: number): boolean {
    switch (step) {
      case 0:
        return this.schedaForm.get('bacino')?.valid === true &&
               this.schedaForm.get('comune')?.valid === true &&
               //this.schedaForm.get('titolo')?.valid === true &&
               this.schedaForm.get('oggettoIntervento')?.valid === true &&
               this.schedaForm.get('codiceAto')?.valid === true;
      case 1:
        // Nessun requisito obbligatorio per i file
        return true;
      case 2:
        // Per ora non ci sono validazioni per la mappa
        return true;
      default:
        return false;
    }
  }

  isFormValid(): boolean {
    return this.schedaForm.valid;
  }

  onUploadPdf(event: any): void {
    const files = event.files;
    if (files && files.length > 0) {
      this.uploadedPdf    = files[0];
      this.uploadedPdfName = files[0].name;
    }
  }

  onUploadExcel(event: any): void {
    const files = event.files;
    if (files && files.length > 0) {
      this.uploadedExcel = files[0];
      this.uploadedExcelName = files[0].name;
    }
  }

  onGeoJSONSelect(event: any): void {
    const file = event.files[0];
    if (file) {
      this.uploadedGeoJSON = file;
      // Leggiamo il contenuto del file GeoJSON
      const reader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const geoJSONData = JSON.parse(e.target.result);
          // Convertiamo le coordinate da EPSG:32632 a EPSG:4326
          const convertedGeoJSON = this.convertCoordinates(geoJSONData);
          // Inizializziamo la mappa e aggiungiamo il layer con il GeoJSON
          // Aspettiamo che il container della mappa sia disponibile
          setTimeout(() => {
            if (this.mapContainer && this.mapContainer.nativeElement) {
              this.initializeMap(convertedGeoJSON);
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Errore mappa',
                detail: 'Container della mappa non disponibile',
                life: 5000
              });
            }
          }, 100); // Aumentiamo il timeout per dare più tempo al DOM di aggiornarsi
        } catch (error) {
          console.error('Errore nel parsing del file GeoJSON:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Il file GeoJSON non è valido',
            life: 5000
          });
        }
      };
      reader.readAsText(file);
    }
  }

  private convertCoordinates(geoJSON: any): any {
    // Definiamo le proiezioni
    const fromProj = 'EPSG:32632';
    const toProj = 'EPSG:4326';

    // Funzione per convertire una singola coordinata
    const convertCoordinate = (coord: number[]): number[] => {
      const [x, y] = coord;
      const [lon, lat] = proj4(fromProj, toProj, [x, y]);
      return [lon, lat];
    };

    // Funzione per convertire ricorsivamente le coordinate
    const convertCoordinatesRecursive = (coordinates: any): any => {
      if (Array.isArray(coordinates[0])) {
        return coordinates.map((coord: any) => convertCoordinatesRecursive(coord));
      } else {
        return convertCoordinate(coordinates);
      }
    };

    // Creiamo una copia profonda del GeoJSON
    const convertedGeoJSON = JSON.parse(JSON.stringify(geoJSON));

    // Convertiamo le coordinate per ogni feature
    convertedGeoJSON.features = convertedGeoJSON.features.map((feature: any) => {
      if (feature.geometry) {
        switch (feature.geometry.type) {
          case 'Point':
            feature.geometry.coordinates = convertCoordinate(feature.geometry.coordinates);
            break;
          case 'LineString':
            feature.geometry.coordinates = feature.geometry.coordinates.map(convertCoordinate);
            break;
          case 'MultiLineString':
            feature.geometry.coordinates = feature.geometry.coordinates.map((lineString: any) =>
              lineString.map(convertCoordinate)
            );
            break;
          case 'Polygon':
            feature.geometry.coordinates = feature.geometry.coordinates.map((ring: any) =>
              ring.map(convertCoordinate)
            );
            break;
          case 'MultiPolygon':
            feature.geometry.coordinates = feature.geometry.coordinates.map((polygon: any) =>
              polygon.map((ring: any) => ring.map(convertCoordinate))
            );
            break;
          case 'GeometryCollection':
            feature.geometry.geometries = feature.geometry.geometries.map((geom: any) => {
              if (geom.coordinates) {
                geom.coordinates = convertCoordinatesRecursive(geom.coordinates);
              }
              return geom;
            });
            break;
        }
      }
      return feature;
    });

    return convertedGeoJSON;
  }

  initializeMap(geoJSONData?: any): void {
    // Se la mappa è già inizializzata, rimuoviamo il layer esistente
    if (this.mapInitialized && this.map) {
      // Rimuoviamo prima i layer
      if (this.map.getLayer('geojson-layer-point')) {
        this.map.removeLayer('geojson-layer-point');
      }
      if (this.map.getLayer('geojson-layer-fill')) {
        this.map.removeLayer('geojson-layer-fill');
      }
      if (this.map.getLayer('geojson-layer-line')) {
        this.map.removeLayer('geojson-layer-line');
      }
      // Poi rimuoviamo la sorgente
      if (this.map.getSource('geojson-source')) {
        this.map.removeSource('geojson-source');
      }
    }

    // Verifichiamo che il container della mappa esista
    if (!this.mapContainer || !this.mapContainer.nativeElement) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore mappa',
        detail: 'Container della mappa non disponibile',
        life: 5000
      });
      return;
    }

    const initialState = {
      lng: 7.200,  // Longitudine Valle di Susa
      lat: 45.1381, // Latitudine Valle di Susa (Susa)
      zoom: 10.8    // Livello di zoom per vedere tutta la valle
    };

    try {
      // Configurazione per lo stile della mappa con OpenStreetMap
      this.map = new maplibregl.Map({
        container: this.mapContainer.nativeElement,
        style: {
          version: 8,
          sources: {
            'osm-tiles': {
              type: 'raster',
              tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
              tileSize: 256,
            }
          },
          layers: [
            {
              id: 'osm-tiles',
              type: 'raster',
              source: 'osm-tiles',
              minzoom: 0,
              maxzoom: 19
            }
          ]
        },
        center: [initialState.lng, initialState.lat],
        zoom: initialState.zoom,
        attributionControl: { compact: true }
      });

      // Aggiungiamo listener per sapere quando la mappa è caricata
      this.map.on('load', () => {
        this.mapInitialized = true;
        this.mapContainer.nativeElement.classList.add('map-loaded');

        // Se abbiamo dati GeoJSON, li aggiungiamo alla mappa
        if (geoJSONData) {
          this.map.addSource('geojson-source', {
            type: 'geojson',
            data: geoJSONData
          });

          // Aggiungiamo il layer di riempimento solo per poligoni
          this.map.addLayer({
            id: 'geojson-layer-fill',
            type: 'fill',
            source: 'geojson-source',
            filter: ['any', ['==', ['geometry-type'], 'Polygon'], ['==', ['geometry-type'], 'MultiPolygon']],
            paint: {
              'fill-color': '#628395',
              'fill-opacity': 0.4,
              'fill-outline-color': '#628395'
            }
          });

          // Aggiungiamo il layer del contorno per linee e poligoni
          this.map.addLayer({
            id: 'geojson-layer-line',
            type: 'line',
            source: 'geojson-source',
            filter: ['any',
              ['==', ['geometry-type'], 'LineString'],
              ['==', ['geometry-type'], 'Polygon'],
              ['==', ['geometry-type'], 'MultiLineString'],
              ['==', ['geometry-type'], 'MultiPolygon']
            ],
            paint: {
              'line-color': '#628395',
              'line-width': 2
            }
          });

          // Aggiungiamo il layer per i punti
          this.map.addLayer({
            id: 'geojson-layer-point',
            type: 'circle',
            source: 'geojson-source',
            filter: ['==', ['geometry-type'], 'Point'],
            paint: {
              'circle-radius': 8,
              'circle-color': '#628395',
              'circle-stroke-width': 2,
              'circle-stroke-color': '#ffffff'
            }
          });

          // Zoom sulla geometria caricata
          const bounds = new maplibregl.LngLatBounds();

          // Funzione per aggiungere coordinate ai bounds
          const addCoordinatesToBounds = (coordinates: any) => {
            if (Array.isArray(coordinates[0])) {
              coordinates.forEach((coord: number[] | number[][]) => addCoordinatesToBounds(coord));
            } else {
              bounds.extend(coordinates as [number, number]);
            }
          };

          // Processa tutte le feature nel GeoJSON
          geoJSONData.features.forEach((feature: any) => {
            if (feature.geometry) {
              switch (feature.geometry.type) {
                case 'Point':
                  bounds.extend(feature.geometry.coordinates as [number, number]);
                  break;
                case 'LineString':
                  feature.geometry.coordinates.forEach((coord: number[]) => {
                    bounds.extend(coord as [number, number]);
                  });
                  break;
                case 'MultiLineString':
                  feature.geometry.coordinates.forEach((lineString: number[][]) => {
                    lineString.forEach((coord: number[]) => {
                      const [lon, lat] = coord;
                      if (lon >= -180 && lon <= 180 && lat >= -90 && lat <= 90) {
                        bounds.extend(coord as [number, number]);
                      } else {
                        console.warn('Coordinate MultiLineString non valide ignorate:', coord);
                      }
                    });
                  });
                  break;
                case 'Polygon':
                  feature.geometry.coordinates[0].forEach((coord: number[]) => {
                    bounds.extend(coord as [number, number]);
                  });
                  break;
                case 'MultiPolygon':
                  feature.geometry.coordinates.forEach((polygon: any) => {
                    polygon[0].forEach((coord: number[]) => {
                      bounds.extend(coord as [number, number]);
                    });
                  });
                  break;
                case 'GeometryCollection':
                  feature.geometry.geometries.forEach((geom: any) => {
                    if (geom.coordinates) {
                      addCoordinatesToBounds(geom.coordinates);
                    }
                  });
                  break;
              }
            }
          });

          // Applica lo zoom con padding e limite di zoom
          this.map.fitBounds(bounds, {
            padding: { top: 50, bottom: 50, left: 50, right: 50 },
            maxZoom: 15,
            duration: 1000 // Aggiunge un'animazione fluida
          });
        }

        // Carichiamo i confini dei comuni solo se non sono già stati caricati
        if (!this.confiniComuniCaricati) {
          this.caricaConfiniComuni();
        }

        try {
          // Aggiungiamo i controlli di navigazione
          if (this.map) {
            this.map.addControl(new maplibregl.NavigationControl(), 'top-right');
            this.map.resize();
          }
        } catch (error) {
          console.error('[NUOVA SCHEDA] Errore durante l\'aggiunta dei controlli:', error);
        }
      });

      // Aggiungiamo un handler per eventuali errori
      this.map.on('error', (e: any) => {
        console.error('[MAP] Errore mappa:', e);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore mappa',
          detail: 'Si è verificato un errore durante il caricamento della mappa.',
          life: 5000
        });
      });

    } catch (error) {
      console.error('[MAP] Errore durante l\'inizializzazione della mappa:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore mappa',
        detail: 'Si è verificato un errore durante l\'inizializzazione della mappa.',
        life: 5000
      });
    }
  }

  onSubmit(): void {
    if (this.schedaForm.valid && this.currentStep === 2) {
      this.submitting = true;

      const formData = this.schedaForm.value;

      let bacino: Bacino = formData.bacino;
      let comune: Comune = formData.comune;
      let codiceAto: CodiceATO | NuovoCodiceATO = formData.codiceAto;
      let oggettoIntervento: OggettoIntervento = formData.oggettoIntervento;
      //let titolo: string = formData.titolo;
      let note: string = formData.note;
      let accessibilita: Accessibilita = formData.accessibilita;
      let rioLocalita: string = formData.rioLocalita;
      let frequenza: number = formData.frequenza;

      // Leggiamo il contenuto del GeoJSON se presente
      let geoJSONContent: any = null;
      if (this.uploadedGeoJSON) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          try {
            geoJSONContent = JSON.parse(e.target.result);
            this.creaSchedaConGeoJSON(geoJSONContent);
          } catch (error) {
            console.error('Errore nel parsing del GeoJSON:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Errore',
              detail: 'Errore nel processare il file GeoJSON',
              life: 5000
            });
            this.submitting = false;
          }
        };
        reader.readAsText(this.uploadedGeoJSON);
      } else {
        this.creaSchedaConGeoJSON(null);
      }
    }
  }

  private creaSchedaConGeoJSON(geoJSONContent: any): void {
    const formData = this.schedaForm.value;

    let schedaDaCreare: CreazioneSchedaDTO = {
      codiceAto: formData.codiceAto,
      nuovoCodiceAto: formData.codiceAto,
      bacino: formData.bacino,
      comune: formData.comune,
      oggettoIntervento: formData.oggettoIntervento,
    //  titolo: formData.titolo,
      note: formData.note,
      accessibilita: formData.accessibilita,
      rioLocalita: formData.rioLocalita,
      frequenza: formData.frequenza,
      xlsCaricato: this.uploadedExcel ? true : false,
      pdfCaricato: this.uploadedPdf ? true : false,
      percorsoXls: this.uploadedExcel?.name ?? null,
      percorsoPdf: this.uploadedPdf?.name ?? null,
      geoJSON: geoJSONContent,
      isEnteEsecutore: this.isEnteEsecutore,
      enteEsecutoreId: this.isEnteEsecutore ? Number(localStorage.getItem("enteId") || 0) : 0
    };
    //this.logger.info( schedaDaCreare);
    this.schedeService.crea(schedaDaCreare).subscribe({
      next: (scheda) => {
        // Carica i file se presenti
        if (this.uploadedExcel) {
          this.uploadFile(this.uploadedExcel, `schede/${scheda.codice}/allegati/${this.uploadedExcel?.name}`);
        }
        if (this.uploadedPdf) {
          this.uploadFile(this.uploadedPdf, `schede/${scheda.codice}/allegati/${this.uploadedPdf?.name}`);
        }
        // Mostra la modale con il codice della scheda creata
        this.codiceSchedaCreata = scheda.codice;
        this.schedaCreataCompleta = scheda;
        this.codiceCopiato = false;
        this.visible = false;
        this.showCodiceModal = true;
        this.submitting = false;
      },
      error: (error) => {
        console.error('Errore nella creazione della scheda:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante la creazione della scheda',
          life: 5000
        });
        this.submitting = false;
      }
    });
  }

  uploadFile(file: File, path: string) {
    this.firebaseStorageService.uploadFile(file, path)
    .subscribe({
      next: () => {
        // this.logger.info(`[CREA SCHEDA] File ${file?.name} caricato con successo`);
      }
    });
  }

  reset() {
    this.uploadedPdf = null;
    this.uploadedExcel = null;
    this.uploadedGeoJSON = null;
    this.uploadedPdfName = '';
    this.uploadedExcelName = '';
    this.currentStep = 0;
    this.schedaForm.reset();
  }

  onPDFSelect(event: any) {
    const files = event.files;
    if (files && files.length > 0) {
      this.uploadedPdf    = files[0];
      this.uploadedPdfName = files[0].name;
    }
    /* if (this.fileSelezionato) {
      this.messageService.add({
        severity: 'info',
        summary: 'File selezionato',
        detail: `"${this.fileSelezionato.name}" pronto per il caricamento`,
        life: 3000
      });
    } */
  }

  onExcelSelect(event: any) {
    const files = event.files;
    if (files && files.length > 0) {
      this.uploadedExcel = files[0];
      this.uploadedExcelName = files[0].name;
    }
  }

  onPDFClear() {
    this.uploadedPdf = null;

   /*  this.messageService.add({
      severity: 'info',
      summary: 'File rimosso',
      detail: 'Seleziona un nuovo file PDF da caricare',
      life: 3000
    }); */
  }

  onExcelClear() {
    this.uploadedExcel = null;
  }

  // Aggiungiamo un metodo per gestire la selezione del bacino
  onBacinoChange(event: any): void {
    const bacinoSelezionato = event.value;
    if (bacinoSelezionato) {
      // this.logger.info(`[NUOVA SCHEDA] Selezionato bacino: ${bacinoSelezionato.denominazione}`);
      this.filtraComuniPerBacino(bacinoSelezionato.id);
    } else {
      this.comuni = [...this.comuniOriginali];
    }
  }

  private filtraComuniPerBacino(bacinoId: number): void {

    this.comuniFiltrati = this.comuniOriginali.filter(comune => {
      return comune.bacini.some(bacino => bacino.id === bacinoId);
    });

    // Aggiorniamo la lista dei comuni visualizzati
    this.comuni = this.comuniFiltrati.length > 0 ? [...this.comuniFiltrati] : [...this.comuniOriginali];

    // this.logger.info(`[COMUNI] Filtrati ${this.comuni.length} comuni per il bacino ID ${bacinoId}`);
  }

  toggleConfiniComuni(): void {
    if (!this.map) return;

    this.opzioniMappa.mostraComuni = !this.opzioniMappa.mostraComuni;

    if (this.map.getLayer('confini-comuni')) {
      this.map.setLayoutProperty('confini-comuni', 'visibility',
        this.opzioniMappa.mostraComuni ? 'visible' : 'none');
    }
  }

  private caricaConfiniComuni(): void {
    if (!this.map || this.confiniComuniCaricati) return;

    try {
      // Aggiungiamo la sorgente per i confini dei comuni
      this.map.addSource('confini-comuni', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        }
      });

      // Aggiungiamo il layer per i confini
      this.map.addLayer({
        id: 'confini-comuni',
        type: 'line',
        source: 'confini-comuni',
        paint: {
          'line-color': '#4b6cb7',
          'line-width': 2,
          'line-opacity': 0.8
        }
      });

      // Carichiamo i confini dal servizio
      this.comuniService.getConfiniComuni().subscribe(confini => {
        if (this.map) {
          const source = this.map.getSource('confini-comuni');
          if (source) {
            source.setData(confini);
            this.confiniComuniCaricati = true;
          }
        }
      });
    } catch (error) {
      console.error('[NUOVA SCHEDA] Errore durante il caricamento dei confini:', error);
    }
  }

  toggleDisegno(): void {
    if (!this.map || !this.draw) return;

    this.modoDisegno = !this.modoDisegno;

    if (this.modoDisegno) {
      // Attiviamo la modalità di disegno
      this.draw.changeMode('draw_polygon');
    } else {
      // Disattiviamo la modalità di disegno
      this.draw.changeMode('simple_select');
    }
  }

  onGeoJSONClear(): void {
    // Rimuoviamo i layer dalla mappa
    if (this.map) {
      if (this.map.getLayer('geojson-layer-fill')) {
        this.map.removeLayer('geojson-layer-fill');
      }
      if (this.map.getLayer('geojson-layer-line')) {
        this.map.removeLayer('geojson-layer-line');
      }
      if (this.map.getLayer('geojson-layer-point')) {
        this.map.removeLayer('geojson-layer-point');
      }
      if (this.map.getSource('geojson-source')) {
        this.map.removeSource('geojson-source');
      }
    }

    // Resettiamo il file
    this.uploadedGeoJSON = null;

    // Mostriamo un messaggio di conferma
    this.messageService.add({
      severity: 'info',
      summary: 'GeoJSON rimosso',
      detail: 'Puoi caricare un nuovo file GeoJSON',
      life: 3000
    });
  }
}
